<template>
    <div class="d-flex align-items-center justify-content-center m-auto" style="height: 100vh;">
        <div class="d-flex align-items-center justify-content-center" v-if="isAttempting">
            <div class="spinner-border mr-3" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <span class="font-size-14">Menghubungkan ke Mobile Counter . . . Harap ditunggu</span>
        </div>
        <div class="align-items-center justify-content-center" style="min-width: 50vw;" v-else-if="alerts.length > 0">
            <div class="d-flex align-items-center justify-content-center mb-2 text-center" style="max-width: 960px;">
                <span class="font-size-14" v-for="alert in alerts" :key="alert.id" @close="removeAlert(alert.id)" close>{{ alert.message }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-center mt-4">
                <button class="col-8 btn bg-template btn-login box-purple ml-2" style="max-width: 250px;" @click="$router.push('/')">
                    <div class="text-capitalize color-white font-weight-bold font-size-11">
                        Kembali ke Halaman Login
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
    data() {
        return {
            code: "",
            mid: "",
            expired: "",
            user: false,
            pass: false,
            sPassword: true,
            showOTP: false,
        };
    },
    computed: {
        ...mapState("auth", ["isAttempting", "fieldErrors", "alerts", "userData"]),
    },
    methods: {
        ...mapMutations("auth", ["removeAlert", "reset"]),
        ...mapActions("auth", ["autoLogin", "loginOtp"]),

        tryAutoLogin() {
            this.autoLogin({ mid: this.mid, expired: this.expired }).then((res) => {
                if (res.otp == true) {
                    this.showOTP = true;
                } else {
                    this.redirect();
                }
            })
        },
        redirect() {
            const { redirect } = this.$route.query;

            if (redirect) {
                this.$router.push("/");
            } else {
                this.$router.push({ name: "transaction" });
            }
        },
    },
    created() {
        this.$store.dispatch("setPageTitle", "Redirecting");
    },
    mounted() {
        this.code = this.$route.query.code;
        if (this.code == '' || this.code == undefined) {
            this.$router.push("/");
        }
        let decode = atob(this.code);
        decode = JSON.parse(decode);
        // alert(decode.mid);
        if (decode !== "") {
            this.mid = decode.mid;
            this.expired = decode.expired;
            this.tryAutoLogin();
        } else {
            this.$router.push("/");
        }
    },
    beforeDestroy() {
        this.reset();
    },
};
</script>
